// extracted by mini-css-extract-plugin
module.exports = {"transactionNarrowGroup":"TransactionNarrowGroup__transactionNarrowGroup__mvmaD"};